<template>
  <div class="f">
    <div class="footer">
      <div class="left-lamp">
        <div class="logo-con">
          <img src="https://res.to2025.com/assets/2/common/img/logo.png" />
          <span>工业汇</span>
        </div>
        <div class="con">工业汇是服务“中国制造2025”的数字化工业社区。我们帮助用户建设数字化营销工具，通过用户提供的产品能力数据和服务能力数据，使用大数据+AI技术帮助用户推广产品和服务，并完成需求对接。</div>
        <h1>400-666-2025</h1>
      </div>
      <div class="right-lamp">
        <h4 v-if="screenWidth>768">关注我们</h4>
        <p v-if="screenWidth>768" class="line"></p>
        <div class="official-account">
          <img src="https://res.to2025.com/assets/2/common/img/th.jpg" alt />
          <p>关注公众号</p>
        </div>
        <div class="small-routine">
          <img src="https://res.to2025.com/assets/2/common/img/bh.jpg" alt />
          <p>扫描使用小程序</p>
        </div>
        <!-- <p class="icp">
          © 2017-2025 to2025.com 版权所有 
        </p>-->
      </div>

    </div>
    <div style="padding:30px 0">
      <a class="icp" href="https://beian.miit.gov.cn" target="_blank">ICP证：京ICP备17000162号-1</a>
      <a class="icp" href="https://beian.miit.gov.cn" target="_blank">信息产业部备案管理系统</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: ["screenWidth"],
  data() {
    return {
      friendLink: [],

    };
  },
  mounted() {

  }
};
</script>

<style scoped>
a,
a:hover {
  color: inherit;
  text-decoration: none;
}
.f {
  /* width: 100%; */
  min-width: 1240px;
  /* padding: 0 100px; */
  background-color: #111;
  box-sizing: border-box;
  /* min-width: 1440px; */
  /* margin-top: 70px; */
}
.f .footer {
  width: 1240px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 35px;
}
.f .footer h2 {
  font-family: PingFangSC;
  font-size: 20px;
  color: #fff;
  border-left: 4px solid #fff;
  height: 20px;
  line-height: 18px;
  padding-left: 10px;
}
.f .footer .con {
  width: 400px;
  font-family: PingFangSC;
  font-size: 16px;
  color: #9b9b9b;
  /* line-height: 1.5; */
  word-wrap: wrap;
  display: flex;
  flex-wrap: wrap;
  margin-top: 14px;
}

.f .footer .right-lamp h4 {
  color: #fff;
  font-size: 16px;
}

.f .footer .right-lamp img {
  width: 80px;
  height: 80px;
  margin: 15px 0;
}
.f .footer .right-lamp p {
  font-family: PingFangSC;
  font-size: 16px;
  color: #fff;
  text-align: center;
}

.f .icp {
  display: block;
  clear: both;
  padding-top: 3px;
  font-size: 0.9em;
  color: #fff;
  margin: 0 auto;
  width: 16em;
  text-align: center;
  border-bottom: none;
}

.f .footer .right-lamp .official-account {
  float: left;
  margin-right: 30px;
}
.f .footer .right-lamp .small-routine {
  float: left;
}
.f .footer .right-lamp .small-routine img {
  margin-left: 16px;
}

.logo-con {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.logo-con img {
  width: 20%;
}

.logo-con span {
  color: #f2f2f2;
  font-size: 20px;
  margin-left: 10px;
}

.left-lamp h1 {
  color: #fff;
  margin-top: 10px;
}

.left-lamp p {
  padding: 10px 0;
  text-align: center;
  border: 1px solid #fff;
  border-radius: 4px;
  color: #f2f2f2;
  width: 144px;
  font-size: 16px;
  margin-top: 10px;
}

.angle {
  display: inline-block;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-left-color: #999;
}

.f .footer .middle-lamp .con {
  width: 300px;
  justify-content: space-between;
}

.f .footer .middle-lamp .con div {
  width: 45%;
  margin-bottom: 10px;
}

.f .footer .middle-lamp .con div:hover {
  color: #327df1;
}

.f .footer .middle-lamp .con div a {
  width: 100%;
}

.f .footer .middle-lamp .con div a img {
  width: 100%;
}

.f .footer .middle-lamp h4 {
  color: #fff;
  font-size: 16px;
}

.line {
  width: 32px;
  height: 2px;
  margin-top: 15px;
  background: #fff;
}

@media screen and (min-width: 769px) {
  .h .header {
    width: 1240px;
    margin: 0 auto;
  }

  .h {
    min-width: 1240px;
  }

  .ht {
    width: 1240px;
    margin: 0 auto;
  }
}

@media screen and (max-width: 768px) {
  .f {
    width: 100%;
    min-width: 0;
    padding: 20px 10px;
  }
  .f .footer {
    flex-direction: column;
    width: 100%;
    height: auto;
    padding: 0;
  }
  .logo-con {
    margin-bottom: 15px;
  }
  .logo-con img {
    width: 16%;
  }

  .left-lamp h1 {
    font-size: 1.4rem;
  }

  .left-lamp p {
    padding: 5px 0;
    width: 110px;
  }

  .f .footer .con {
    width: 100%;
    font-size: 0.9rem;
  }
  .f .footer .middle-lamp {
    margin-top: 20px;
  }

  .f .footer .right-lamp {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indexFooter.vue